export const id = 'dokumente';
export const label = `${id}:label`;
export const route = '/dokumente';
export { FolderOpen as Icon, FolderSpecialOutlined as SecondaryIcon } from '@mui/icons-material';
